<template>
  <div class="profile-placements text-center">
    <TopMenu
      :title="$t('PROFILE.PLACEMENTS.PAGE_LABEL')"
      :back-to="'/dashboard'"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 pr-4 pl-4 text-left">
        <h3>{{ $t('SIDEMENU.PLACEMENTS') }}</h3>
      </div>
      <div
        v-if="!placements || !placements.items || placements.items.length === 0"
        class="col-12 text-center mt-4">
        <h2>{{ $t('PROFILE.NO_PLACEMENTS') }}</h2>
      </div>

      <div v-else>
        <div
          v-for="(placement, index) in getPlacementsOrderedByDate(placements.items)"
          :key="index"
          class="mt-3 pb-2 pr-4 pl-4 text-left border-bottom">
          <office-information
            :office="placement.employeur"
            :is-already-expanded="$route.params.id == placement.id"
            :bold-name="true"
            expandable>
            <h4 class="mt-3">
              {{ dateText(placement) }} <br>
              {{ placement.message }}
            </h4>
            <span>
              <i
                variant="primary"
                class="fas fa-trash pr-2"
                @click="openConfirmModal(placement)"
              />
            </span>
          </office-information>
        </div>
      </div>
      <ConfirmModal
        v-if="showConfirmSubmit"
        show-modal
        size="md"
        @cancel="showConfirmSubmit = false"
        @confirm="deletePlacement">
        <span v-html="deleteInfoMessage"/>
      </ConfirmModal>
    </div>
    <BottomMenu />
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import ActionButton from '@/components/Actions/ActionButton';
import OfficeInformation from '@/components/Information/OfficeInformation';
import ConfirmModal from '@/components/Modal/ConfirmModal';

export default {
  name: 'Placements',
  components: {
    ActionButton,
    TopMenu,
    BottomMenu,
    OfficeInformation,
    ConfirmModal,
  },
  data() {
    return {
      showConfirmSubmit: false,
      placementToDelete: {},
    };
  },
  computed: {
    ...mapState('member', ['placements']),
    ...mapGetters('member', ['getPlacementsOrderedByDate']),
    selectedPlacement() {
      return this.$route.params.id;
    },
    deleteInfoMessage() {
      return this.$t('PROFILE.PLACEMENTS.DELETE', { 0: this.placementToDelete.employeur.name });
    },
  },
  created() {
    if (this.$route.params.id) {
      this.expended = this.$route.params.id;
    }
    this.$store.dispatch('member/currentMemberPlacements');
  },
  methods: {
    dateText(placement) {
      return `${this.$t('PROFILE.PLACEMENTS.DATE')} : ${moment(placement.date).format('YYYY-MM-DD HH:mm')}`;
    },
    openConfirmModal(placement) {
      this.showConfirmSubmit = true;
      this.placementToDelete = placement;
    },
    deletePlacement() {
      this.showConfirmSubmit = false;
      this.$store.dispatch('member/deletePlacement', {
        placement: this.placementToDelete,
      }).then(() => {
        this.$store.commit('alerts/setAlert', {
          msg: 'PROFILE.PLACEMENTS.DELETE_SUCCESS',
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.profile-placements {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
.form-control-plaintext {
  display: inline;
}
.form-control-plaintext {
  width: auto;
  padding-top: 0px;
  padding-bottom: 0px;
  cursor: pointer;
}
a .form-control-plaintext {
  font-weight: bold;
  font-size: 1.6rem;
}
.chevron {
  display: flex;
  align-items: center;
}
.clickable-row,
.fa-trash {
  cursor: pointer;
}
.slide-y-enter-active,
.slide-y-leave-active {
  transition: all 0.5s;
  max-height: 600px;
}
.slide-y-enter,
.slide-y-leave-to {
  max-height: 0;
}
.placement-information {
  overflow: hidden;
}
</style>
